import CTLUnReadCell from "application/components/CTLUnReadCell";
import DefaultCell from "application/components/DefaultCell";
import PlayFile from "../FileAction/Play";
import DownloadFile from "../FileAction/Download";

const Attributes = {
  formSize: "md",
  columns: 3,
  enableAdvanceSearch: false,
  enableGroupHeading: false,
  verticalTabs: false,
  enableConferenceRecording: true,
  selectUrl: "/conference/accessCode/listAll",
  tabSize: 4,
  modes:[],
  settingsMode: false,
};

const getColumns = () => {
  return [
    {
      Header: "Access Code",
      accessor: "accessCode",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Meeting Name",
      accessor: "meetingName",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "File Path",
      accessor: "path",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable:true,
      width: 6,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Recording File",
      accessor: "recordingFile",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Actions",
      accessor: "",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      sortDisable: true,
      Cell: ({ row, value }) => (
        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <PlayFile row={row} value={value} />
          <DownloadFile row={row} value={value} />
        </div>
      ),
    }
  ];
};

export { getColumns, Attributes};
